<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.QueryLCLJobOrder2')"
    width="1085px"
    append-to-body
    :close-on-click-modal="false"
    :before-close="beforeCloseHandler"
    class="app-main-inner query-ai-lcl-dialog"
  >
    <div class="app-main-inner-row">
      <search-item
        ref="searchItem"
        config-module="401"
        :reset="true"
        :show-simple="false"
        :expand-adv="true"
        :custom-search-items="customSearchItems"
        :col-settings="{span:8}"
        :grid-config-module="401002"
        @advSearchItemCallBack="toQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
      />
    </div>
    <div class="app-main-inner-row">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="min-height: 300px;"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        config-module="401002"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div slot="footer" style="display: flex;justify-content: space-between;">
      <span>
        <b>{{ $t('SeaExport.QuantityOfSelectedOrder') }}：{{ selectedRows.length }}</b>
      </span>
      <div>
        <el-button no="add" type="primary" @click="add">{{ $t('SeaExport.Add3') }}</el-button>
        <el-button no="Cancel" @click="beforeCloseHandler(()=>{innerVisible=false})">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { getAirImportJobsByLclMasterJob } from '@/api/AirImport/aiBooking'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { cache, cacheName } from '@/utils/cacheManager'
import CustomLableUtils from '@/utils/CustomLabelUtils'
export default {
  name: 'QueryAILclDialog',
  components: { searchItem },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      filter: {
        loadingPortCode: '',
        jobNo: '',
        voyageFlight: '',
        dischargingPortCode: '',
        mbl: '',
        carrierId: '',
        etdStart: '',
        etdEnd: ''
      },
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          // 重置（多选）选中行
          this.selectedRows = []
        },
        onSelectionChanged: event => {
          this.selectedRows = event.api.getSelectedRows()
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        }, {
          headerName: 'MBL',
          field: 'mbl',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 220,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Payment.portOfDestination'),
          field: 'destinationPortCode',
          width: 130
        }, {
          headerName: 'ETD',
          field: 'etd',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('Pricing.Goods'),
          field: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantityContract',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Weight2'),
          field: 'weightContract',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.number1ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Cubage'),
          field: 'cubageContract',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 120, colId: 'op', hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op') : ''
          }
        }
      ],
      rowData: [],
      customSearchItems: [],
      selectedRows: [],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async initData() {
      await cache.load(cacheName.CONFIG)
      const isJyd = String(cache.config.get('ToExoSystem')) === 'JYD'
      const isAdmin = this.$store.getters.isAdmin

      let searchField = new AdvancedSearchField()
      searchField.itemType = 'airport'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_AIRPORT'
      searchField.itemName = 'job.LOADING_PORT_CODE'
      searchField.itemLabel = 'SeaExport.LoadingPort'
      searchField.itemValue = ''
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = true
      searchField.valueExpression = ''
      searchField.defaultValue = this.job.loadingPortCode
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
      // 操作部门使用主票操作部门，且不可编辑
      searchField = new AdvancedSearchField()
      searchField.itemType = 'department5'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_DEPARTMENT5'
      searchField.itemName = 'job.OP_DEPARTMENT'
      searchField.itemLabel = 'SeaExport.OperationDepartment'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = true
      searchField.defaultValue = [this.job.opDepartment]
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // CARGO-42713 加入小票查询权限逻辑优化-只能操作看自己的
      searchField = new AdvancedSearchField()
      searchField.itemType = 'user'
      searchField.subType = {
        'category': 'role',
        'shape': 'op'
      }
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_USER'
      searchField.itemName = 'job.OP_ID'
      searchField.itemLabel = 'SeaExport.Operation'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = (isJyd && !isAdmin)
      searchField.defaultValue = (isJyd && !isAdmin) ? this.$store.getters.userId : 0
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_TEXT'
      searchField.itemName = 'job.MBL'
      searchField.itemLabel = 'SeaExport.Mbl2'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = true
      searchField.defaultValue = this.job.mbl
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
      searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'job.OPERATE_TYPE'
      searchField.itemLabel = 'SeaExport.OperateType'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = true
      searchField.valueExpression = ''
      searchField.dropdownDataRef = 'AirExportConstants.BUSINESS_MODELS'
      searchField.dataCacheKey = 'local_cache_AirExportConstants$BUSINESS_MODELS'
      searchField.defaultValue = [0]
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
    },
    toQuery(data) {
      let option = AdvancedSearchOption.getOption('job.JOB_NO', data)
      if (option) {
        this.filter.jobNo = option.value
      } else {
        this.filter.jobNo = ''
      }
      option = AdvancedSearchOption.getOption('job.VOYAGE_FLIGHT', data)
      if (option) {
        this.filter.voyageFlight = option.value
      } else {
        this.filter.voyageFlight = ''
      }
      option = AdvancedSearchOption.getOption('job.DISCHARGING_PORT_CODE', data)
      if (option) {
        this.filter.dischargingPortCode = option.value
      } else {
        this.filter.dischargingPortCode = ''
      }
      option = AdvancedSearchOption.getOption('job.CARRIER_ID', data)
      if (option) {
        this.filter.carrierId = option.value
      } else {
        this.filter.carrierId = ''
      }
      option = AdvancedSearchOption.getOption('job.ETD', data)
      this.filter.etdStart = ''
      this.filter.etdEnd = ''
      if (option) {
        const items = option.value.split(',')
        for (let i = 1; i < items.length && i < 3; ++i) {
          if (items[i].startsWith('start=')) {
            this.filter.etdStart = items[i].substr(6)
          } else if (items[i].startsWith('end=')) {
            this.filter.etdEnd = items[i].substr(4)
          }
        }
      }
      this.filter.loadingPortCode = this.job.loadingPortCode
      this.filter.mbl = this.job.mbl
      getAirImportJobsByLclMasterJob(this.filter).then(res => {
        this.rowData = res.data
      })
    },
    async add() {
      const selectedRows = this.selectedRows // 记录当前选中的记录，避免后续被修改
      if (selectedRows.length === 0) {
        this.$message.info('请选择要加入的小票')
        return
      }
      if (!this.job.mbl) {
        this.$message.info(this.$t('queryJob.ThePleaseMaintainTheFirst'))
        return
      }
      const triggerCallback = () => {
        this.$emit('callback', selectedRows)
        this.innerVisible = false
      }
      if (!(this.hasDiffField(selectedRows))) {
        this.$confirm(this.$t('queryJob.TheTheNewlySelectedContinue'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          this.fixNewSlave(selectedRows)
          triggerCallback()
        }).catch(() => { })
      } else {
        triggerCallback()
      }
    },
    hasDiffField(selectedRows) {
      for (const slave of selectedRows) {
        if (slave.vessel !== this.job.vessel) {
          return false
        }
        if (slave.voyageFlight !== this.job.voyageFlight) {
          return false
        }
        if (slave.eta !== this.job.eta) {
          return false
        }
        if (slave.etd !== this.job.etd) {
          return false
        }
        if (slave.releaseTypeMbl !== this.job.releaseTypeMbl) {
          return false
        }
        if (slave.carrierId !== this.job.carrierId) {
          return false
        }
        if (slave.paymentTermMBL !== this.job.paymentTermMBL) {
          return false
        }
      }
      return true
    },
    fixNewSlave(selectedRows) {
      for (const item of selectedRows) {
        item.vessel = this.job.vessel
        item.voyageFlight = this.job.voyageFlight
        item.eta = this.job.eta
        item.etd = this.job.etd
        item.releaseTypeMbl = this.job.releaseTypeMbl
        item.carrierId = this.job.carrierId
        item.paymentTermMBL = this.job.paymentTermMBL
      }
    },
    beforeCloseHandler(done) {
      this.$confirm(this.$t('Message.CancelTheCurrentQuery'), this.$t('CargoMsg.Cargo_ConfirmR'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        done()
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss">
.app-main-inner.query-ai-lcl-dialog {
  label {
    font-size: 12px;
    font-weight: normal;
  }
  .el-select {
    width: 100%;
  }
}
</style>
